import React, { useEffect, useState } from "react";
import Card from "components/card";
import {
  getProject,
  updateProject,
  uploadProjectImage,
} from "services/projects";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "components/Toast";

const EditProject: React.FC = () => {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        const { data } = await getProject(Number(id));
        setTitle(data.title || "");
        setSummary(data.summary || "");
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    try {
      await updateProject(Number(id), { title, summary });
      if (file) {
        const fd = new FormData();
        fd.append("image", file);
        await uploadProjectImage(Number(id), fd);
      }
      navigate("/admin/projects");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to update project");
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Edit Project</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm">Title</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm">Summary</label>
          <textarea
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm">Image</label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files?.[0] ?? null)}
          />
        </div>
        <div>
          <button
            type="submit"
            className="rounded bg-indigo-600 px-4 py-2 text-white"
          >
            Save
          </button>
        </div>
      </form>
    </Card>
  );
};

export default EditProject;
// (removed duplicate placeholder)
